import {
  CircularProgress as MuiCircularProgress,
  CircularProgressProps as MuiCircularProgressProps,
} from "@mui/material";

export const Spinner = (props: MuiCircularProgressProps) => {
  return <MuiCircularProgress {...props} />;
};
